import type { baseApi } from './services/baseApi'

type Tags = Parameters<typeof baseApi.util.invalidateTags>[0]

// Tags a mutation invalidates only reach the tab that ran it — every tab has
// its own store. Mutations whose effect shows on a page people keep open in
// another tab (the ERA pages, while a payment is reversed on the patient's)
// pass their tags along here, and each other tab invalidates them too.
const channel: BroadcastChannel | null =
  typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel('rtk-query-invalidation')

export const invalidateInOtherTabs = (tags: Tags): void => {
  try {
    channel?.postMessage({ tags })
  } catch {
    // Another tab missing an update is no reason to fail this one.
  }
}

export const listenForOtherTabsInvalidation = (invalidate: (tags: Tags) => void): void => {
  if (!channel) return

  channel.onmessage = (event: MessageEvent<{ tags?: Tags }>) => {
    if (Array.isArray(event.data?.tags)) {
      invalidate(event.data.tags)
    }
  }
}
